import { lazyLoadView } from '@router/helpers';
export default [
  {
    path: '/i/:id(\\d+)/peserta',
    name: 'peserta',
    component: () => lazyLoadView(import('@views/instansi/peserta/List')),
    meta: {
      title: 'Peserta Non Dapodik',
    },
  },
  {
    path: '/i/:id(\\d+)/petugas/kelas/bcmp',
    name: 'petugas-kelas-bcmp',
    component: () => lazyLoadView(import('@views/instansi/peserta/Bcmp')),
    meta: {
      title: 'Kelas Petugas Bimtek BCMP',
      jenis: 'bcmp_petugas',
    },
  },
  {
    path: '/i/:id(\\d+)/peserta/kelas/bcmp',
    name: 'peserta-kelas-bcmp',
    component: () => lazyLoadView(import('@views/instansi/peserta/Bcmp')),
    meta: {
      title: 'Kelas Peserta Bimtek BCMP',
      jenis: 'bcmp_peserta',
    },
  },
  {
    path: '/i/:id(\\d+)/peserta/kelas/bcmp/:kelas_id',
    name: 'peserta-kelas-bcmp-detail',
    component: () => lazyLoadView(import('@views/instansi/peserta/formulir/KelasBcmp')),
    meta: {
      title: 'Detail Kelas',
      jenis: 'bcmp_peserta',
    },
  },
  {
    path: '/i/:id(\\d+)/petugas/kelas/refreshment',
    name: 'petugas-kelas-refreshment',
    component: () => lazyLoadView(import('@views/instansi/peserta/Refreshment')),
    meta: {
      title: 'Kelas Petugas Bimtek PPM & PPTM',
      jenis: 'refreshment_petugas',
    },
  },
  {
    path: '/i/:id(\\d+)/petugas/kelas/refreshment/:kelas_id',
    name: 'petugas-kelas-refreshment-detail',
    component: () => lazyLoadView(import('@views/instansi/peserta/formulir/PesertaRefreshment.vue')),
    meta: {
      title: 'Kelas Petugas Bimtek PPM & PPTM',
      jenis: 'refreshment_petugas_detail',
    },
  },
  {
    path: '/i/:id(\\d+)/peserta/kelas/refreshment',
    name: 'peserta-kelas-refreshment',
    component: () => lazyLoadView(import('@views/instansi/peserta/Refreshment')),
    meta: {
      title: 'Kelas Peserta Bimtek PPM & PPTM',
      jenis: 'refreshment_peserta',
    },
  },
  {
    path: '/i/:id(\\d+)/peserta/kelas/refreshment/:kelas_id/peserta/:peserta_id',
    name: 'peserta-kelas-refreshment-detail',
    component: () => lazyLoadView(import('@views/instansi/peserta/formulir/KelasRefreshment')),
    meta: {
      title: 'Detail Kelas',
      jenis: 'refreshment_peserta',
    },
  },
];
